export const PLAN_ORDER_MBOX = 'OE-665-mbox';
export const mboxes = [PLAN_ORDER_MBOX];
